import React, { useState, useEffect, useRef } from "react";
import getLocalData from "../../../shared/localStorage/getData";
import getRemoveData from "../../../shared/localStorage/removeData";
import combinedServices from "../../../shared/services/user-service";
import { Spinner } from "reactstrap";
import setLocalData from "../../../shared/localStorage/setData";
import { useLocation } from "react-router-dom";

const AdminUserLogin = (props) => {

  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await combinedServices.getAllUserAdmin();
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredUsers = users.filter(user =>
    `${user.user_firstname} ${user.user_lastname} ${user.email}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleUserSelect = async (userId) => {
    setIsLoading(true);
    try {
      const adminToken = localStorage.getItem("admin_info");
      const loginResponse = await combinedServices.adminLoginWithUserId(userId);

      if (loginResponse.status === 200) {
        getRemoveData("admin_info");
        getRemoveData("admin_info_backup");
        localStorage.setItem("parent_token", loginResponse.data.token);
        const userSession = { login_user_detail: loginResponse };
        setLocalData("user_info", userSession);
        window.location.href = "/club-dashboard";
      }
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setIsLoading(false);
      setIsOpen(false);
      setSearchTerm("");
    }
  };

  return (
    <div className="admin-user-dropdown" 
      style={{ position: 'relative', minWidth: '250px' }}
      ref={dropdownRef}>
      <div 
        className="dropdown-input"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '45px',
          border: '2px solid #1c60a6',
          borderRadius: '4px',
          padding: '8px 12px',
          cursor: 'pointer',
          backgroundColor: '#fff',
          fontSize: '16px',
          fontWeight: '600',
          color: '#1c60a6',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap'
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isLoading ? "Logging in..." : "Login as User"}
      </div>
      
      {isOpen && (
        <div 
          className="dropdown-menu"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 1000,
            maxHeight: '200px',
            overflow: 'hidden',
            display: 'block',
          }}
        >
          <input
            type="text"
            name="search"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '8px 12px',
              border: 'none',
              borderBottom: '1px solid #eee',
              outline: 'none',
              fontSize: '14px'
            }}
            autoFocus
          />
          <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
            {filteredUsers.map((user) => (
              <div
                key={user.id}
                onClick={() => handleUserSelect(user.id)}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f5f5f5',
                  fontSize: '14px',
                  ':hover': { backgroundColor: '#f8f9fa' }
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
              >
                {user.user_firstname} {user.user_lastname}
              </div>
            ))}
            {filteredUsers.length === 0 && (
              <div style={{ padding: '8px 12px', color: '#666', fontSize: '14px' }}>
                No users found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default AdminUserLogin;
